import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { stringToParsedTokenArray } from "@poscon/shared-types/eram";
import { useDispatch } from "react-redux";
import { eramFontDimensionMap, eramFontNameMap, getBitmapTextStyles } from "../../eramFont.js";
import { colorNameMap } from "../../colorNameMap.js";
import { setSelectedAdvisory } from "../slices/commonSlice.js";
import { EramPrompt } from "./EramPrompt.js";
import { useCenterCursor } from "../hooks/useCenterCursor.js";
import { MenuElement } from "./MenuElement.js";
export const advDeleteView = "ADV_DELETE";
const fontFamily = eramFontNameMap[2];
const fontDim = eramFontDimensionMap[fontFamily];
export const advDeleteWidth = 30 * fontDim.width;
const height = fontDim.height * 2 + 12;
export const AdvDeletePrompt = ({ dispatchCommand, adv, ref, ...promptProps }) => {
    const localRef = useRef(null);
    const dispatch = useDispatch();
    useCenterCursor(localRef, advDeleteWidth, fontDim.height + 4);
    const saveAdv = () => {
        dispatchCommand(stringToParsedTokenArray(`UM /D ${adv.name}`));
        dispatch(setSelectedAdvisory(null));
    };
    const text = `DELETE ${adv.name}${adv.sectorCreatedShort ? `(${adv.sectorCreatedShort})` : ""}?`;
    return (_jsxs(EramPrompt
    // @ts-ignore
    , { 
        // @ts-ignore
        ref: ref, title: "DELETE ADVISORY", width: advDeleteWidth, height: height, closeMenu: () => {
            dispatch(setSelectedAdvisory(null));
        }, showX: true, ...promptProps, children: [_jsx("bitmapText", { x: (advDeleteWidth - text.length * fontDim.width) / 2, y: 4, text: text, style: { ...getBitmapTextStyles(fontFamily), fill: colorNameMap.lightGrey } }), _jsxs("container", { ref: localRef, y: height - fontDim.height, children: [_jsx(MenuElement, { x: (advDeleteWidth / 2 - fontDim.width * 6 - 2) / 2, text: "DELETE", onmousedown: saveAdv }), _jsx(MenuElement, { x: ((advDeleteWidth * 3) / 2 - fontDim.width * 2 - 2) / 2, text: "EXIT", onmousedown: () => dispatch(setSelectedAdvisory(null)) })] })] }));
};
//# sourceMappingURL=AdvDeletePrompt.js.map